// ©2024 Austin App House. All rights reserved.

export const MOBILE_NAV_MQ = '(max-width: 768px)';
export const SIDEBAR_PINNED_KEY = 'wurqly:sidebar-pinned';

export const isMobileNav = () => window.matchMedia(MOBILE_NAV_MQ).matches;

export const getSidebarPinned = () => {
  if (isMobileNav()) return false;

  try {
    return localStorage.getItem(SIDEBAR_PINNED_KEY) === 'true';
  } catch {
    return false;
  }
};

export const setSidebarPinned = (pinned) => {
  try {
    localStorage.setItem(SIDEBAR_PINNED_KEY, pinned ? 'true' : 'false');
  } catch {
    // Ignore storage errors (private mode, quota, etc.)
  }
};
